import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import { animated } from 'react-spring'

import { useHooks } from './methods'

import Container from './style'

export interface Props {
  href?: string
  children: ReactNode | string
  defaultWithUnderline?: boolean
  rel?: string
  target?: string
  style?: CSSProperties
  className?: string
  id?: string
}

export interface State {
  isHovered: boolean
}

function InlineLink({
  id,
  children,
  className,
  style,
  defaultWithUnderline,
}: Props): ReactElement {
  const { underlineSpring, setHover, resetHover } = useHooks(
    defaultWithUnderline,
  )

  return (
    <Container
      id={id}
      className={className}
      style={style}
      onMouseEnter={setHover}
      onMouseLeave={resetHover}
    >
      {children}
      <figure>
        <animated.div
          className="anchor-underline"
          style={underlineSpring}
        ></animated.div>
      </figure>
    </Container>
  )
}

InlineLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  defaultWithUnderline: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

InlineLink.defaultProps = {
  className: '',
  defaultWithUnderline: false,
}

export default memo(InlineLink)
